const initialState={
	reventas:[],
	Estado:0
};	


export default function shoppingCartReducer(state=initialState,action){
	switch(action.type){
		case 'MODIFY':
     		return {...state,reventas:action.payload }  
     	case 'ESTADO':
     		return {...state,Estado:action.payload }    	
     	default:
     		return state
	}
}